import React from 'react';

import BaseTimezoneSelect, { BaseTimezoneSelectProps } from 'src/components/date-time-picker/BaseTimezoneSelect';

import { useDisplayTimezone } from 'src/contexts/DisplayTimezoneProvider';
import { useLastUsedTimezones } from 'src/contexts/LastUsedTimezonesProvider';

export type TimezoneSelectProps = Omit<BaseTimezoneSelectProps, 'lastUsedTimezones'> & {
  shouldUpdateDisplayTimezone?: boolean;
};

/**
 * Use this component when you want to show timezone picker that is common across ModernLoop app
 * Updating timezone will update all the display times according to selected timezone.
 */
const TimezoneSelect = (props: TimezoneSelectProps): JSX.Element => {
  const { onChange, value, shouldUpdateDisplayTimezone, ...rest } = props;
  const [lastUsedTimezones, { add: addLastUsedTimezone, remove: removeLastUsedTimezone }] = useLastUsedTimezones();
  const [displayTimezone, setDisplayTimezone] = useDisplayTimezone();

  const handleChange = (timezone: string) => {
    if (onChange) {
      onChange(timezone);
    }

    addLastUsedTimezone(timezone);

    if (shouldUpdateDisplayTimezone) {
      setDisplayTimezone(timezone);
    }
  };

  const timezone = value ?? displayTimezone ?? 'UTC';

  return (
    <BaseTimezoneSelect
      {...rest}
      lastUsedTimezones={lastUsedTimezones}
      onRemoveRecentTimezone={removeLastUsedTimezone}
      onChange={handleChange}
      value={timezone}
    />
  );
};

export default TimezoneSelect;
